module.exports = __webpack_public_path__ + "img/2840ebc829df046252939b4a6dcb2950.1ed48eb0.webp";